// extracted by mini-css-extract-plugin
export default {"notAnswered":"WhenNotAnswered_notAnswered__nic+y"};